const env = process.env.VUE_APP_ENVIRONMENT || 'local';
export default {
  env: require('./' + env + '.json'),
  help: require('./help.json'),
};
